import Reveal from "@/components/Reveal";
import StoreButtons from "@/components/StoreButtons";

export default function AppDownload() {
  return (
    <section id="app" className="py-24 px-6 border-y border-[#00F0FF]/20 relative overflow-hidden bg-gradient-to-b from-[#061536] to-[#02050F] scroll-mt-20" data-testid="app-download-section">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <Reveal className="lg:col-span-7">
          <span className="font-mono-lbl text-xs text-[#FF1E8C] uppercase tracking-widest block mb-3">Native Mobile Experience</span>
          <h2 className="font-disp text-4xl sm:text-6xl uppercase tracking-tight mb-6">
            Total Control in <span className="text-[#00F0FF]">One Gesture</span>
          </h2>
          <p className="text-white/80 text-base leading-relaxed mb-8 max-w-xl">
            Download the LuxeRay Smart Homes app for real-time sensor analytics, customized ambient scenes, and voice AI sync.
          </p>

          <StoreButtons size="lg" testid="download" />
        </Reveal>

        <Reveal className="lg:col-span-5 flex justify-center" delay={150}>
          <div className="w-64 sm:w-72 aspect-[9/19] rounded-[40px] border-4 border-white/20 p-3 bg-[#061536] shadow-2xl relative" data-testid="app-phone-mockup"
            style={{ background: "radial-gradient(120% 100% at 50% 20%, #00F0FF33 0%, transparent 70%), linear-gradient(180deg, #061536, #02050F)" }}>
            <div className="w-full h-full rounded-[30px] border border-white/10 p-4 flex flex-col justify-between">
              <div>
                <div className="flex justify-between items-center text-[10px] font-mono-lbl text-white/50 mb-4">
                  <span>9:41</span>
                  <span>AIoT SYNC 100%</span>
                </div>
                <div className="flex items-center gap-2 mb-3">
                  <img src="/luxeray-app-icon.png" alt="LuxeRay app icon" className="w-8 h-8 rounded-lg" data-testid="app-mockup-icon" />
                  <div>
                    <div className="text-[10px] font-mono-lbl text-[#00F0FF] uppercase leading-none">Living Suite</div>
                    <div className="text-base font-bold leading-tight">Evening Ambiance</div>
                  </div>
                </div>
                <div className="space-y-2">
                  <div className="bg-white/5 p-2 rounded border border-white/10 text-[10px]">
                    <div className="flex justify-between mb-1"><span>LuxeRay OLED Master</span><span className="text-[#00F0FF]">80%</span></div>
                    <div className="w-full bg-white/10 h-1.5 rounded-full overflow-hidden"><div className="bg-[#00F0FF] h-full w-4/5" /></div>
                  </div>
                  <div className="bg-white/5 p-2 rounded border border-white/10 text-[10px]">
                    <div className="flex justify-between mb-1"><span>Climate Control</span><span className="text-[#FF1E8C]">21.5°C</span></div>
                    <div className="w-full bg-white/10 h-1.5 rounded-full overflow-hidden"><div className="bg-[#FF1E8C] h-full w-2/3" /></div>
                  </div>
                </div>
              </div>
              <div className="text-center font-mono-lbl text-[9px] text-white/40 uppercase">Native LuxeRay Hub</div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
